import { makeStyles, Theme } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';

export const useStyles = makeStyles((theme: Theme) => ({
  wraper: {
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
    display: 'flex',
  },
  root: {
    width: 28,
    height: 16,
    padding: 0,
    //marginRight: theme.spacing(1),
    //marginLeft: theme.spacing(1),
    //display: 'flex',
  },
  switchBase: {
    padding: 2,
    color: theme.palette.grey[500],
    '&$checked': {
      transform: 'translateX(12px)',
      color: theme.palette.common.white,
      '& + $track': {
        opacity: 1,
        backgroundColor: green[500],
        borderColor: green[500],
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: 'none',
  },
  track: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.common.white,
  },
  tooltip: {
    fontSize: '10px',
  },
  checked: {},
  focusVisible: {},
}));
